/**
 * Copyright (C) Mairistem
 *
 * Unauthorized copying of this file, via any medium is strictly prohibited.
 *
 * Proprietary and confidential
 */

import _ from 'lodash';
import React from 'react';

import { _fn } from '@mairistem/administres-utils';
import { Liste } from '@mairistem/liste';

import type { SituationScolaire } from '@/types';

import SituationScolaireListeTable from './SituationScolaireListeTable';

interface Props {
  /** Nombre de lignes */
  count?: number;
  /** État du chargement */
  loading?: boolean;
  /** Callback appelé lors du chargement de la liste */
  onLoad?: () => void;
  /** Callback appelé lors d'une saisie dans la barre de recherche */
  onSearch?: (value: string) => Promise<void>;
  /** Callback appelé lors d'un filtrage sur la liste */
  onSort?: () => void;
  /** Nombre de lignes par page */
  perPage?: number;
  /** Données de la liste */
  situationsScolaires?: SituationScolaire[];
  /** Callback appelé lors de la sélection d'un item */
  onSelect?: (qualification: SituationScolaire) => void;
  /** Callback appelé lors de la sauvegarde */
  onSave?: (qualification: SituationScolaire) => void;
  /** Situation scolaire sélectionnée */
  selectedSituationScolaire?: SituationScolaire;
  /** Callback appelé lors de la réinitialisation des lignes */
  resetSelectedItems?: (qualification: SituationScolaire) => void;
}

const SituationScolaireListe = (props: Props) => {
  const {
    count = 0,
    perPage = 50,
    situationsScolaires = [],
    selectedSituationScolaire = {},
    loading = false,
    // selection = false,
    onLoad = null,
    onSearch = null,
    onSort = null,
    onSelect = null,
    onSave = null,
    resetSelectedItems = null,
    ...rest
  } = props;

  const handleSelect = React.useCallback(
    (qualification: SituationScolaire, qualifications: SituationScolaire[]) => {
      _fn(onSelect, !_.isEmpty(qualifications) ? qualification : {});
    },
    [onSelect],
  );

  return (
    <Liste searchable title="" onSearch={onSearch} loading={loading} {...rest}>
      <Liste.Content>
        <SituationScolaireListeTable
          items={situationsScolaires}
          count={count}
          loading={loading}
          onLoad={onLoad}
          onSelect={handleSelect}
          perPage={perPage}
          onSort={onSort}
          onSave={onSave}
          selectedSituationScolaire={selectedSituationScolaire}
          resetSelectedItems={resetSelectedItems}
        />
      </Liste.Content>
    </Liste>
  );
};

export default SituationScolaireListe;
